import { Node } from '@tiptap/core'
import { VueNodeViewRenderer, mergeAttributes } from "@tiptap/vue-3"
import View from "./View.vue"

export default Node.create({
  name: 'Card',

  group: 'block',

  content: '(paragraph|heading?)+',

  draggable: true,

  addAttributes() {
    return {
      href: {
        default: ''
      },
      src: {
        default: ''
      },
      alt: {
        default: null
      },
      size: {
        default: 10
      },
      padding: {
        default: 2
      },
      target: {
        default: '_self',
      }
    }
  },

  parseHTML() {
    return [
      {
        tag: 'tt-card',
      },
    ]
  },

  renderHTML({ HTMLAttributes }) {
    return ['tt-card', mergeAttributes(HTMLAttributes), 0]
  },

  addNodeView() {
    return VueNodeViewRenderer(View)
  }
})
